import React, { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { ColumnsType } from 'antd/lib/table';
import { Row, Col, Divider, Skeleton, Table } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

import { Title } from '@/components/Typography';
import { ScoreTable } from '../components/ScoreTable';
import { BeraResultCycleSummary, BeraResultHighestRPNScores, BeraResultRPNScoresByStepKey } from '@/types/Bera';
import * as S from './styles';

interface ResultBeraProps {
	isLoading?: boolean;
	cycleSummary: BeraResultCycleSummary;
	highestRPNs: BeraResultHighestRPNScores;
}

export function ResultBera({ isLoading = false, cycleSummary, highestRPNs }: Readonly<ResultBeraProps>): JSX.Element {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	if (isLoading) {
		return <Skeleton active />;
	}

	const byStepKeyColumns: ColumnsType<BeraResultRPNScoresByStepKey> = [
		{
			title: I18n.get('Position'),
			key: 1,
			align: 'center',
			render: (_, __, index) => index + 1
		},
		{
			title: I18n.get('TLID'),
			dataIndex: 'task_name',
			key: 2,
			ellipsis: true,
			align: 'center'
		},
		{
			title: I18n.get('Risk factor'),
			dataIndex: 'step_key_description',
			key: 3,
			ellipsis: true,
			align: 'center',
			responsive: ['md'],
			render: (step_key_description) => I18n.get(step_key_description)
		},
		{
			title: I18n.get('RPN'),
			dataIndex: 'rpn',
			key: 4,
			align: 'center'
		}
	];

	return (
		<React.Fragment>
			<Row justify="center" onClick={() => setIsOpen(!isOpen)} style={{ cursor: 'pointer', marginTop: '2rem' }}>
				<Col span={22}>
					<Row>
						<Title level={5}>{I18n.get('B.E.R.A. Result')}</Title>
					</Row>
				</Col>

				<Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
					{isOpen ? <UpOutlined /> : <DownOutlined />}
				</Col>
			</Row>
			<Divider type="horizontal" />
			{isOpen && (
				<Row justify="center">
					<Col span={22}>
						<Row justify="start" style={{ marginBottom: '1rem' }}>
							<Title level={5}>{I18n.get('Cycle summary')}</Title>
						</Row>
						<Row justify="center">
							<ScoreTable cycleSummary={cycleSummary} isENS={false} />
						</Row>
					</Col>
					<Col span={22} style={{ marginTop: '1rem' }}>
						<Row justify="start" style={{ marginBottom: '1rem' }}>
							<Title level={5}>{I18n.get('Five highest RPNs')}</Title>
						</Row>
						<S.CustomTable span={24}>
							<Table
								rowKey="id"
								pagination={false}
								dataSource={highestRPNs?.by_step_key}
								columns={byStepKeyColumns}
							/>
						</S.CustomTable>
					</Col>
				</Row>
			)}
		</React.Fragment>
	);
}
